import React from 'react'
import './Testimonios.css'

// Imágenes de ejemplo (puedes reemplazarlas por fotos reales o íconos)
import paciente1 from '../assets/images/user.png'
import paciente2 from '../assets/images/user.png'
import paciente3 from '../assets/images/user.png'

const testimonios = [
  {
    id: 1,
    nombre: 'Carolina',
    tipo: 'xx',
    texto:
      'Llegué con años de síntomas sin diagnóstico claro. La Dra. Barber me escuchó con calma, explicó cada examen y me ayudó a recuperar mi equilibrio hormonal. Su trato humano y su claridad me devolvieron la confianza en la medicina.',
    img: paciente1,
  },
  {
    id: 2,
    nombre: 'Ricardo',
    tipo: 'xx',
    texto:
      'Gracias al tratamiento y seguimiento de la doctora, logré controlar mi glicemia y cambiar mis hábitos de vida. Se nota que domina su especialidad y realmente se preocupa por cada paciente, no solo por los resultados clínicos.',
    img: paciente2,
  },
  {
    id: 3,
    nombre: 'Chery',
    tipo: 'Paciente en etapa de menopausia',
    texto:
      'Excelente profesional, dedicada y atenta a sus pacientes. Me sentí muy acompañada durante todo el proceso. La Dra. Barber combina conocimiento médico y empatía, explicando de forma sencilla lo que me ocurría.',
    img: paciente3,
  },
]

const Testimonios = () => {
  return (
    <section className="testimonios-container" id="afiliaciones">
      <h2>Testimonios de Pacientes</h2>

      <div className="testimonios-grid">
        {testimonios.map(({ id, nombre, tipo, texto, img }) => (
          <article key={id} className="testimonio-item">
            <img src={img} alt={nombre} className="testimonio-img" loading="lazy" />
            <h3>{nombre}</h3>
            {/* <span className="testimonio-tipo">{tipo}</span> */}
            <p className="testimonio-texto">{texto}</p>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Testimonios
